import React from 'react';
import './cta.css';

const CTA = () => (
  <div className="gpt3__cta" id='library' >
    <div className="gpt3__cta-content">
      <p>Checkout the Library which was used for Building this Awesome Project</p>
      <h3>Chat GPT3 Open AI Library</h3>
    </div>
    <div className="gpt3__cta-btn">
    <a href="https://beta.openai.com/docs/guides/code"><button type="button">Checkout</button></a>  
    </div>
  </div>
);

export default CTA;
